import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "The3DCurveManual"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.2502 15.75C11.2502 16.9926 10.2429 18 9.00021 18H8.92521C8.54019 16.1138 6.78944 14.8255 4.87407 15.019C2.9587 15.2125 1.50098 16.8249 1.50098 18.75C1.50098 20.6751 2.9587 22.2875 4.87407 22.481C6.78944 22.6745 8.54019 21.3862 8.92521 19.5H9.00021C9.99477 19.5 10.9486 19.1049 11.6519 18.4016C12.3551 17.6984 12.7502 16.7446 12.7502 15.75H11.2502ZM5.2502 21C4.00756 21 3.0002 19.9926 3.0002 18.75C3.0002 17.5074 4.00756 16.5 5.2502 16.5C6.49284 16.5 7.5002 17.5074 7.5002 18.75C7.5002 19.9926 6.49284 21 5.2502 21ZM11.2502 9.75H12.7502V14.25H11.2502V9.75ZM18.7502 1.5C16.9679 1.49964 15.4317 2.75375 15.0752 4.5H15.0002C12.9291 4.5 11.2502 6.17893 11.2502 8.25H12.7502C12.7502 7.00736 13.7576 6 15.0002 6H15.0752C15.4699 7.93348 17.2955 9.23027 19.2511 8.9663C21.2067 8.70233 22.6231 6.96792 22.491 4.999C22.3589 3.03008 20.7235 1.5004 18.7502 1.5ZM18.7502 7.5C17.5076 7.5 16.5002 6.49264 16.5002 5.25C16.5002 4.00736 17.5076 3 18.7502 3C19.9928 3 21.0002 4.00736 21.0002 5.25C21.0002 6.49264 19.9928 7.5 18.7502 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/The3DCurveManual.vue"]]);
